import { enUS, nb } from 'date-fns/locale'

const LOCALES = {
  en: enUS,
  no: nb
}

export { LOCALES }
